import styled from '@react-pdf/styled-components';
import { ContainerRadius } from '../styles';

export const TaskDetails = styled(ContainerRadius)`
  width: 100%;
  height: 650px;
  padding: 20px;
  margin: 30px 0;
`;

export const ContainerDetails = styled.View`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px 0;
`;

export const Question = styled.View`
  padding: 0 20px 30px;
  width: 45%;
`;
